<template>
	<div>
		<footer class="foot">
			<div class="other">
				<div style="display: flex; width: 773px;margin: 0 auto;justify-content: center;">
					<div class="otherRight">
						<div class="otherRightItem">
							<div class="otherRightItemTitle">快速链接</div>
							<div class="navigationList">
								<router-link to="/" class="otherRightItemText">首页 <span class="navBlock"></span>
								</router-link>
								<router-link to="/exampleList" class="otherRightItemText">应用案例 <span
										class="navBlock"></span></router-link>
								<router-link to="/newsList" class="otherRightItemText">筑橙新闻 <span
										class="navBlock"></span>
								</router-link>
								<router-link to="/aboutUs" class="otherRightItemText">关于我们 <span
										class="navBlock"></span></router-link>
							</div>
						</div>
						<div class="otherRightItem" style="margin-top:35px;">
							<div class="otherRightItemTitle">筑橙科技</div>
							<div @click="openUrl()" class="otherRightItemText" style="padding-left: 0;cursor: pointer;">
								数字平台</div>
						</div>
					</div>
					<div class="otherLeft">
						<div>
							<img class="wechat" src="../resource/images/QRCode.jpg">
							<div class="linkOur">微信公众号</div>
						</div>
					</div>
				</div>

			</div>
			<div class="copyright"><span class="cursor-pointer" @click="openUrl('https://beian.miit.gov.cn/')">粤ICP备2021049963号</span>
				Copyright @ 筑橙科技（深圳）有限公司</div>
		</footer>
	</div>

</template>

<script>
	export default {
		name: 'foot',
		data() {
			return {

			}
		},
		methods: {
			openUrl(url = "http://dp.zanecon.cn/") {
				window.open(url)
			}
		},
	}
</script>


<style scoped>
	.cursor-pointer {
		cursor: pointer;
	}

	.navBlock {

		position: absolute;
		right: 0px;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 1px;
		height: 11px;
		background-color: #858585;
		opacity: .4;
	}

	.navigationList {
		display: flex;
		margin-right: 210px;

	}

	.otherRight {
		/* display: flex; */
		padding-top: 56px;
		box-sizing: border-box;
	}

	.otherRightItem {
		margin-right: 80px;
	}

	.otherRightItem:nth-last-child(1) {
		margin-right: 0;
	}

	.otherRightItemText {
		display: block;
		line-height: 22px;
		font-size: 14px;
		font-weight: 400;
		text-align: left;
		color: #858585;
		/* margin-bottom: 8px; */
		position: relative;
		padding: 0 15px;
		flex: 1 0 auto;
	}

	.otherRightItemText:nth-child(1) {
		padding-left: 0;
	}

	.otherRightItemText:nth-last-child(1) .navBlock {
		display: none;
	}

	.otherRightItemTitle {
		margin-bottom: 12px;
		line-height: 28px;
		opacity: 0.8;
		font-size: 20px;
		font-weight: 700;
		text-align: left;
		color: #fff;
	}

	.wechat {
		width: 130px;
		height: 130px;
		display: block;
	}

	.linkOur {
		margin-top: 10px;
		text-align: center;
		line-height: 22px;
		opacity: 0.6;
		font-size: 16px;
		font-weight: 400;
		color: #fff;
	}

	.otherLeft {
		/* display: flex;
		align-items: center; */
		display: flex;
		align-items: center;
	}

	.other {
		background: #262626;
		height: 279px;
		display: flex;
	}

	.copyright {
		text-align: center;
		width: 100%;
		line-height: 86px;
		height: 86px;
		font-size: 14px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		color: #707070;
		background: #191919;
	}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue